import { createApp } from 'vue'

//@ts-ignore
import router from './config/pc_routes'
//@ts-ignore
import global from './config/global'
//@ts-ignore
import ElementPlus from 'element-plus'
//@ts-ignore
import directive from './directive/index';
// import { device } from "vue-device-detector"
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
// import 'bootstrap-icons/font/bootstrap-icons.css'
import 'file-icon-vectors/dist/file-icon-square-o.min.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/appicon/iconfont.css'
import '@/assets/kioskicon/iconfont.css'
//@ts-ignore
import {i18n} from './locale/i18n'
//@ts-ignore
import pinia from './store'

import './tailwind.css'
import './style.scss'
import App from './App.vue'
//@ts-ignore
import eventBus from 'vue3-eventbus'
import * as Sentry from "@sentry/vue";
import { HttpClient } from "@sentry/integrations";
// import panZoom from 'vue-panzoom'

import layout from 'vue3-grid-layout-next'
// import mitt from 'mitt';

// 注入生产环境的HTTP客户端
import { ApiClient, initDefaultClient } from '@arcubase/client-ts'
import {
  authMiddleware,
  slauthSessionMiddleware,
  formDataMiddleware,
  versionCheckMiddleware,
  dataTransformMiddleware,
  businessErrorMiddleware,
  requestLogMiddleware
} from '@/api/middlewares'
import { useUserStore } from "@/store/user"
import {
  createRuntimeVersionChecker,
  installRuntimeVersionDetector,
  notifyAppUpgradeDetected
} from '@/utils/runtimeVersion'
import { hasCachedSession, restoreSession, syncTenant } from '@/auth/sessionRuntime'

// 创建并配置ApiClient实例
const apiClient = new ApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 10000
})

// 添加通用中间件
apiClient
  .addMiddleware(requestLogMiddleware)      // 请求日志
  .addMiddleware(slauthSessionMiddleware)   // 从 slauth-ts 异步解析最新 session/token
  .addMiddleware(authMiddleware)            // 认证处理
  .addMiddleware(formDataMiddleware)        // 表单数据处理
  .addMiddleware(versionCheckMiddleware)    // 版本检查
  .addMiddleware(businessErrorMiddleware)   // 业务错误处理
  .addMiddleware(dataTransformMiddleware)   // 数据转换

// 初始化默认客户端（供新 API 使用）
initDefaultClient(apiClient)

installRuntimeVersionDetector({
  router,
  checker: createRuntimeVersionChecker({
    currentVersion: import.meta.env.VITE_BUILD_VERSION || '',
    versionUrl: '/public/app-version.json',
    onUpgradeDetected: notifyAppUpgradeDetected,
  }),
})

async function bootstrap() {
  const app = createApp(App)

  //@ts-ignore
  const shouldIgnoreError = (event) => {
    if (event.message && event.message.includes("AbortError")) {
      return true;
    }
    return false;
  }
  //@ts-ignore
  if(import.meta.env.PROD){
    Sentry.init({
      app,
      dsn: "https://7195dad634e82f920b97e9c51d4f739f@o4505717410365440.ingest.sentry.io/4505717412528128",
      //@ts-ignore
      integrations: [new HttpClient()],
      ignoreErrors: [
        'Failed to fetch',
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
    //@ts-ignore
    Sentry.setTag("BUILD_VERSION", window.BUILD_VERSION)
  }

  app.use(pinia)
  await restoreSession()

  // 检查持久化恢复状态
  const userStore = useUserStore()
  console.log('[main.js] Store restored from localStorage:', {
    hasSession: hasCachedSession(),
    hasUser: !!userStore.user,
    userId: userStore.user?.ID,
    hasAuth: !!userStore.auth,
    hasTenant: !!userStore.tenant,
    tenantId: userStore.tenant?.ID,
    haslogin: hasCachedSession()
  })

  // 检查 localStorage 原始数据
  const localStorageRaw = localStorage.getItem('user')
  console.log('[main.js] Raw localStorage "user":', localStorageRaw ? localStorageRaw.substring(0, 200) + '...' : 'null')

  // 设置 store（必须在 pinia 初始化之后）
  apiClient.setStore(userStore)

  // 同步 tenant 到 client（token 由 slauth-ts restore 自动接管）
  if (userStore.tenant?.ID) {
    syncTenant(userStore.tenant.ID)
  }

  app.use(ElementPlus)
  app.use(eventBus)
  app.use(i18n)
  app.use(router)
  // app.use(store)
  app.use(global)
  // app.use(device)
  app.use(directive)
  app.use(layout)
  // app.use(panZoom)

  //@ts-ignore
  app.config.globalProperties.$store = useUserStore();

  //@ts-ignore
  const fixMessageFunc = (oldfunc) => {
    //@ts-ignore
    const func = (options) => {
      if(typeof options === 'string'){
        options = {
          message: options
        }
      }
      options.grouping = true
      options.showClose = true
      // options.plain = true
      return oldfunc(options)
    }
    return func
  }

  app.config.globalProperties.$message.error = fixMessageFunc(app.config.globalProperties.$message.error)
  app.config.globalProperties.$message.success = fixMessageFunc(app.config.globalProperties.$message.success)
  app.config.globalProperties.$message.warning = fixMessageFunc(app.config.globalProperties.$message.warning)

  app.mount('#app')
}

bootstrap()
